// Apolo IDE — persistMessages (E5-WS2-T01).
//
// Persists a turn's messages with HONEST failure handling. The old SessionWorkspace
// sites did `try { for (body) await apiFetch(POST) } catch { /* best effort */ }` —
// doubly silent: apiFetch returns {ok:false} on HTTP error (it does NOT throw) so the
// loop ignored failures, AND the catch only caught throws. A failed POST silently
// dropped the message → the turn vanished on reload. Now each POST's ok is checked and
// any failure is logged + surfaced via a toast. Framework-free (D4) — unit-testable
// with only apiFetch mocked. Returns the failure count.
import { apiFetch } from './api.js';

export async function persistMessages(sessionId, bodies) {
  const list = (bodies || []).filter(Boolean);
  let failed = 0;
  for (const body of list) {
    let res;
    try {
      res = await apiFetch(`/api/code/sessions/${sessionId}/messages`, { method: 'POST', body });
    } catch {
      res = { ok: false };
    }
    if (!res?.ok) failed += 1;
  }
  if (failed > 0) {
    console.warn(
      `[persistMessages] ${failed}/${list.length} message(s) failed to persist (session ${sessionId}) — may be missing after reload`,
    );
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('apolo:toast', {
        detail: { kind: 'warn', message: `${failed} mensagem(ns) deste turno não foram salvas — podem sumir ao recarregar.` },
      }));
    }
  }
  return failed;
}
